var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _vm._m(0),
    _vm._v(" "),
    _c("strong", { staticClass: "tit_gallery" }, [_vm._v(_vm._s(_vm.message))]),
    _vm._v(" "),
    _c("span", { staticClass: "txt_regulate" }, [
      _vm.showsBlindArticle
        ? _c(
            "a",
            {
              staticClass: "link_regulate",
              attrs: { href: _vm.blindArticleUrl }
            },
            [_vm._v("원문보기")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "link_regulate box_regulation",
          attrs: { href: _vm.restrictionUrl, target: "_blank" }
        },
        [_vm._v("규제관련 안내")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "group_thumb" }, [
      _c("span", { staticClass: "box_thumb" }, [
        _c("span", { staticClass: "img_thumb album_regulate" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("cafe 규제 이미지")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }